<template>
  <b-container>
    <b-row class="headline" align-v="center">
      <b-col class="header" cols="*" v-if="playlist.id">
        Edit
      </b-col>
      <b-col class="header" cols="*" v-else>
        Create
      </b-col>
    </b-row>
    <b-row class="command-row" align-v="center">
      <b-col>
        <h1 v-if="playlist.type === 'my-videos'">
          Saved Videos
        </h1>
        <h1 v-else-if="playlist.id">
          {{ playlist.name }}
        </h1>
        <h1 v-else>
          Create New Playlist
        </h1>
      </b-col>
      <b-col cols="*">
        <router-link v-if="playlist.id" :to="{name: 'fan-playlist-detail', params: { id: playlist.id }}">cancel</router-link>
        <router-link v-else :to="{name: 'fan-playlist-list', meta: { type: 'my' }}">cancel</router-link>
        <b-button class="btn-rainbow" @click="savePlaylist" :disabled="$v.playlist.$invalid">save</b-button>
      </b-col>
    </b-row>

    <b-row class="playlist-details first" v-if="isRegularPlaylist">
      <b-col>
        <b-form-group label="Playlist Name"
                      label-for="name">
          <b-form-input type="text"
                        required
                        placeholder="Name of the playlist"
                        v-model="playlist.name" />
        </b-form-group>

        <b-form-checkbox v-model="playlist.is_public">
            Publicly available (other users may view and follow it)
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="playlist-details videos-headline">
      <b-col>
        <h3>Videos</h3>
      </b-col>
    </b-row>

    <SongListEditor v-model="videos"
                    :canAdd="false"
                    :canRemove="true"
                    :canSort="true">
    </SongListEditor>

    <b-row class="playlist-details no-videos" v-if="!videos.length">
      <b-col>
        You have not added any videos yet
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .headline {
    margin-top: 1.5em;
    margin-bottom: 1em;

    box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.5);
    margin-bottom: 2em;

    .header {
      font-weight: bold;
      padding: 1em;
      border-bottom: 2px solid white;
    }

    .cancel {
      text-align: right;
    }

    a {
      color: $white;
    }
  }

  .command-row {
    margin-bottom: 1em;

    a {
      color: $white;
      text-decoration: underline;
    }

    .btn-rainbow {
      margin-left: 2em;
      padding-left: 2em;
      padding-right: 2em;
    }

    h1 {
      font-size: 1.5em;
    }

    &.bottom {
      margin-top: 1em;
      text-align: right;
    }
  }

  .playlist-details {
    padding: 1em 0 1em 1em;

    &.first {
      background-image: linear-gradient(to bottom, #1e1f36, rgba(0, 0, 0, 0));
    }

    &.last {
      box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.5);
    }

  }

  .videos-headline {
    .col {
      margin-top: 1em;
      margin-left: -15px;
    }

    h3 {
      font-size: 1.5em;
    }

    border-bottom: 1px solid $slate-blue;
    margin-bottom: 10px;
  }

  .no-videos {
    text-align: center;
    font-size: 0.8em;
    color: $steel;
  }
</style>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import SongListEditor from '@/components/widgets/SongListEditor'

export default {
  name: 'EditPlaylist',
  components: {
    FontAwesomeIcon,
    SongListEditor
  },
  mixins: [validationMixin],
  data () {
    return {
      playlist: {},
      videos: []
    }
  },
  validations: {
    playlist: {
      name: {
        required
      }
    }
  },
  computed: {
    isRegularPlaylist () {
      return !this.playlist.type || this.playlist.type === 'playlist'
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData () {
      if (!this.$route.params.id) {
        this.playlist = {}
        return
      }

      let profile = this.$store.getters['profile/currentUser']
      let playlist = await this.$store.dispatch('playlist/getPlaylist', {id: this.$route.params.id})
      if (playlist.profile.id !== profile.id) {
        this.$router.push({name: 'fan-playlist-list', meta: { type: 'my' }})
        return
      }

      this.parsePlaylist(playlist)
    },
    parsePlaylist (playlist) {
      this.playlist = playlist
      this.videos = playlist.videos
    },
    async savePlaylist () {
      if (this.$v.playlist.$invalid) return

      this.$store.dispatch('flash/showModal', 'Saving ...')

      const videoIds = []
      for (let video of this.videos) {
        videoIds.push(video.id)
      }
      this.playlist.video_ids = videoIds

      let isCreate = !this.playlist.id
      let resp = await this.$store.dispatch(isCreate ? 'playlist/createPlaylist' : 'playlist/updatePlaylist', this.playlist)

      this.parsePlaylist(resp)

      if (isCreate) {
        this.$store.dispatch('flash/showMessage', {message: 'Playlist created'})
      } else if (this.playlist.type === 'my-videos') {
        this.$store.dispatch('flash/showMessage', {message: 'Saved Videos updated'})
        this.playlist.video_ids = videoIds
        this.$store.getters['profile/currentUser'].default_playlists.my_videos = this.playlist
      } else {
        this.$store.dispatch('flash/showMessage', {message: 'Playlist updated'})
      }

      this.$store.dispatch('flash/hideModal')
      this.$router.push({name: 'fan-playlist-detail', params: { id: this.playlist.id }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/EditPlaylist.vue